export default __webpack_public_path__ + "assets/icon-receipt-white.d3f3654c.webp";